import React from 'react';
import icons from 'style';
import { PlayButton, StyledSVGInline } from './ButtonPlayOutline.css';

type PropType = {
    onClick?: (e) => void;
    assetId?: string;
    screenName?: string;
    style?: {};
};

export const ButtonPlayOutline: React.FC<PropType> = ({ onClick, ...rest }) => {
    const handleClick = (e) => {
        if (onClick) {
            onClick(e);
        }
    };

    return (
        <PlayButton data-test-id={'stripe-card-play-button'} onClick={handleClick} {...rest}>
            <StyledSVGInline svg={icons.playIcon} />
        </PlayButton>
    );
};
